import { useMutation } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export function useRequestPasswordResetMutation() {
  return useMutation({
    mutationFn: SSF.api.authPasswordResetCreate,
  });
}

export function useConfirmPasswordResetMutation() {
  return useMutation({
    mutationFn: SSF.api.authPasswordResetConfirmCreate,
  });
}
